export default "__VITE_ASSET__BFthytUG__"